























import {
    isMobileLayout,
    useI18n,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import { SdsFlag } from '@superbet-group/web.lib.ui-components';
import {
    computed,
    defineComponent,
} from '@vue/composition-api';

import { BreadcrumbItem } from '@shared/components/breadcrumbs/types';
import SdsPageHeader from '@shared/components/pageHeader/SdsPageHeader.vue';
import { TabItem } from '@shared/components/tabs/types';
import { useCompetitionsDataSources } from './useCompetitionsDataSources';
import { RouteName } from '@app/router/constants/RouteName';
import { useCompetitionRouteParams } from './useCompetitionRouteParams';
import { AvailableCompetitionTabs } from '@sportOfferFederation/competitions/store/ui/types';
import { getFlagByCategory } from '@sportOfferFederation/flags/flagMapping';
import { TimeFilterSlug } from '@store/modules/ui/shared/timeFilter/utils';
import { CompetitionsUIStore } from '../store/ui';

export default defineComponent({
    name: 'SdsCompetitionBaseHeader',
    setup() {
        const { translate } = useI18n();
        const competitionsStore = useVuexStore<CompetitionsUIStore>('ui/competitions');

        const selectedTab = competitionsStore.state('selectedTab');
        const availableTabs = competitionsStore.getter('availableTabs');
        const setSelectedTab = competitionsStore.action('setSelectedTab');

        const {
            sportName,
            categoryName,
            competitionName,
            seoCompetitionTitle,
            currentCategoryId,
        } = useCompetitionsDataSources();

        const {
            sportSlug,
        } = useCompetitionRouteParams();

        const breadcrumbs = computed((): BreadcrumbItem[] => [
            {
                label: sportName.value,
                to: {
                    name: RouteName.Sport.CategoryPerTime,
                    params: {
                        sportSlug: sportSlug.value,
                        timeFilter: TimeFilterSlug.Today,
                    },
                },
            },
            {
                label: categoryName.value,
                to: {
                    name: RouteName.Sport.SportCompetitions,
                    params: {
                        sportSlug: sportSlug.value,
                    },
                    query: {
                        categoryId: currentCategoryId.value?.toString() ?? '',
                    },
                },
            },
        ]);

        const tabs = computed<TabItem[]>(() => {
            return availableTabs.value.map((tab) => {
                const className = ['e2e-competition-tab', `e2e-competition-tab-${tab.id}`];

                let badgeText: string | undefined;
                let isNewBadge = false;

                if (tab.id === 'ig') {
                    className.push('social-e2e-event-details-insights-tab');
                } else if (tab.id === 'so') {
                    className.push('social-e2e-event-details-social-tab');

                    if (tab.showBadge) {
                        badgeText = translate('social.betting_room.promo_new');
                        isNewBadge = true;
                    }
                }

                return {
                    value: tab.id,
                    label: translate(tab.name.toString()).toString(),
                    className: className.join(' '),
                    badgeText,
                    isNewBadge,
                };
            });
        });

        function onTabChange(value: AvailableCompetitionTabs): void {
            setSelectedTab(value);
            window.scrollTo({
                top: 0,
            });
        }

        return {
            title: seoCompetitionTitle,
            competitionFlag: computed(() => currentCategoryId.value ? getFlagByCategory(currentCategoryId.value) : null),
            competitionName,
            breadcrumbs: computed(() => isMobileLayout() ? [] : breadcrumbs.value),
            tabs,
            onTabChange,
            selectedTab,
        };
    },
    components: {
        SdsFlag,
        SdsPageHeader,
    },
});
